import React from "react";
import { DataSection } from "../components";

const meetingFields = [
  { key: "title", label: "Sitzung", type: "text" },
  { key: "date", label: "Datum", type: "date" },
  { key: "location", label: "Ort", type: "text" },
  { key: "agenda", label: "Traktanden (eine Zeile pro Punkt)", type: "lines" },
  { key: "status", label: "Status", type: "select", options: ["geplant", "protokolliert", "abgesagt"], badge: true },
];

const resolutionFields = [
  { key: "title", label: "Beschluss", type: "text" },
  { key: "decision", label: "Beschlusstext", type: "textarea", table: false },
  { key: "result", label: "Ergebnis", type: "text" },
  { key: "date", label: "Datum", type: "date" },
  { key: "status", label: "Status", type: "select", options: ["beschlossen", "vertagt", "abgelehnt"], badge: true },
];

const Meetings = () => (
  <div className="space-y-16">
    <DataSection overline="Gremium" title="Sitzungen" entity="meetings" fields={meetingFields} />
    <DataSection overline="Revisionssicher" title="Beschlüsse (Protokoll)" entity="resolutions" fields={resolutionFields} />
  </div>
);
export default Meetings;
